
















































































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {baseUrl} from "@/service/ApiClient";

import Modal from '@/components/UI/Modal.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';

import IArrow from '@/components/icons/IArrow.vue'
import IClose from '@/components/icons/IClose.vue'
import ICheck from '@/components/icons/ICheck.vue'

const newauth = namespace('newauth')
const profile = namespace('profile')
const dialog = namespace('dialog')
const forms = namespace('forms')
const resources = namespace('resources')
const app = namespace('app')


@Component({
  components: {
    Modal,
    BtnDefault,
    IArrow,
    IClose,
    ICheck,
  }
})
export default class WorkspacesList extends Vue {
  @newauth.Getter('registrationSuccess') protected registrationSuccess: any
  @newauth.Action('logout') protected logout: any
  @profile.Getter('userCompanies') protected userCompanies: any
  @profile.Getter('getUserInvites') protected getUserInvites: any
  @profile.Action('rejectInviteFromServer') protected rejectInviteFromServer: any
  @profile.Action('acceptInviteFromServer') protected acceptInviteFromServer: any
  @profile.Getter('getUser') protected getUser: any

  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any
  @app.Action('sendMailToSupport') protected sendMailToSupport: any

  @Prop({type: Boolean, default: false}) protected isToolbar!: boolean

  showOrganizer: boolean = false
  isDialogPhoneErrorValid: boolean = false
  isDialogCodeError: boolean = false
  isDialogPhoneError: boolean = false
  loadingOrganizer: boolean = false
  isErrorOrganizer: boolean = false
  code: string = ''
  phone: string = ''
  baseURL: any = baseUrl()

  get filteredCompanies() {
    return this.isToolbar ?
        this.userCompanies ? this.userCompanies.filter((company: any) => company.company.code != this.currentWorkspace) : []
        : this.userCompanies
  }

  get codes() {
    return this.getCountries.map((el: any) => {
      return {
        code: '+' + el.phoneCode,
        flagIcon: el.flagIcon
      }
    })
  }

  get currentWorkspace() {
    return localStorage.getItem('workspace')
  }

  @Watch('showOrganizer')
  resetForm() {
    this.code = ''
    this.phone = ''
  }

  addCompany() {
    this.SetTitleDialog(this.$t('workspace.create_company.title'))
    this.SetFormSDialog('CreateCompanyForm')
    this.SetFullDialogShow(true)
  }

  setCompany(company: any) {
    // console.log( company.company.code)
    // localStorage.setItem('workspace', company.company.code)
    this.$router.push({name: "Corporate", params: {code: company.company.code}}).catch(() => {
    })
  }

  setPersonal() {
    // localStorage.setItem('workspace', 'personal')
    this.$router.push({name: "Corporate", params: {code: 'personal'}}).catch(() => {
    })
    // this.$router.push({name:"Corporate"})
    // this.$router.push({ name: 'Personal' })
  }

  async tryLogout() {
    this.$router.push({name: 'Logout'}).catch(() => {
    })
  }

  openModalOrganizer() {
    this.getCountryFromServer()
    this.showOrganizer = true
  }

  send() {
    this.loadingOrganizer = true
    this.isDialogCodeError = this.code == ''
    this.isDialogPhoneError = this.phone == ''
    this.isDialogPhoneErrorValid = !this.validPhone()
    if (!this.isDialogCodeError && !this.isDialogPhoneError && !this.isDialogPhoneErrorValid) {
      this.$emit('changeTitle')
      this.sendMailToSupport({
        name: this.getUser.firstName + ' ' + this.getUser.lastName,
        email: this.getUser.contacts.filter((cont: any) => {
          return cont.type = 'email'
        })[0] ? this.getUser.contacts.filter((cont: any) => {
          return cont.type = 'email'
        })[0].value : '',
        phone: this.code + this.phone || '',
        reason: 'be_organizer'
      })
      this.loadingOrganizer = false
      this.showOrganizer = false
    } else {
      this.loadingOrganizer = false
    }
  }

  validPhone() {
    let re = /^[\d\+][\d\(\)\ -]{4,20}\d$/
    return re.test(this.phone)
  }

  acceptInvite(invite: any) {
    this.acceptInviteFromServer(invite)
  }

  rejectInvite(invite: any) {
    this.rejectInviteFromServer(invite)
  }

}
